// ═══════════════════════════════════════════════════════════════════════════
// Fase 3B, paso 3 del cutover — lectura de las tablas precalculadas
// (crm_actividad_resumen_grupos/..._contactos, migración
// 20260920_crm_actividad_resumen_precalculado.sql) que alimentan el CRM
// (VentasMiListaClientesV2) y Mapa de Calor. El dual-run (paso 2) terminó
// limpio — docs/decisiones/2026-09-20-fase3b-diseno-actividad-precalculada.md.
//
// LEER_ACTIVIDAD_PRECALCULADA: constante única (10.188/10.251 — un solo lugar
// para volver atrás). En true, el CRM y Mapa de Calor leen estas tablas y NO
// disparan el camino viejo (getCrmActividades.js) ni el dual-run
// (dualRunActividades.js). En false, revierte al camino viejo intacto.
// ═══════════════════════════════════════════════════════════════════════════

import { client } from ".";

export const LEER_ACTIVIDAD_PRECALCULADA = true;

const CHUNK = 300;
const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const fetchPorClienteIds = async (table, columns, clienteIds) => {
  if (clienteIds.length === 0) return [];
  const batches = chunk(clienteIds, CHUNK);
  const results = await Promise.all(
    batches.map(async (ids) => {
      const { data, error } = await client.from(table).select(columns).in("cliente_id", ids);
      if (error) {
        // eslint-disable-next-line no-console
        console.error(`[actividadPrecalculada] error leyendo ${table}`, error);
        return [];
      }
      return data || [];
    })
  );
  return results.flat();
};

/** Grano (cliente_id, lado, tipo, dia) — los grupos "xN" del CRM. */
export const fetchResumenGrupos = (clienteIds) =>
  fetchPorClienteIds(
    "crm_actividad_resumen_grupos",
    "cliente_id,lado,tipo,dia,cantidad,ultima_fecha_del_grupo,calculado_at",
    clienteIds
  );

/** Grano (cliente_id, lado, usuario_id) — última fecha por contacto puntual. */
export const fetchResumenContactos = (clienteIds) =>
  fetchPorClienteIds(
    "crm_actividad_resumen_contactos",
    "cliente_id,lado,usuario_id,ultima_fecha,calculado_at",
    clienteIds
  );

/**
 * Última corrida del cron, SIN filtrar por cliente_id — señal independiente de si el país/lote
 * consultado tiene filas propias. Si el cron nunca corrió (o la tabla está vacía), devuelve null
 * — el llamador debe decirlo explícitamente en vez de mostrar vacío en silencio (10.177).
 */
export const fetchUltimoCalculo = async () => {
  const { data, error } = await client
    .from("crm_actividad_resumen_grupos")
    .select("calculado_at")
    .order("calculado_at", { ascending: false })
    .limit(1);
  if (error || !data || data.length === 0) return null;
  return data[0].calculado_at;
};
